"use strict";

require("core-js/modules/esnext.weak-map.delete-all.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Icon = _interopRequireWildcard(require("./Icon"));
const _excluded = ["fill"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const IconBookOpen = _ref => {
  let {
      fill
    } = _ref,
    others = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_Icon.default, (0, _extends2.default)({
    label: "Book Open"
  }, others), /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.9333 1C12.6797 1.00967 11.0043 1.32 9.792 1.85633C8.88733 2.25633 8.53333 2.559 8.53333 3.58433V14.3333C9.919 13.0833 11.1487 12.7333 16 12.7333V1H14.9333ZM1.06667 1C3.32033 1.00967 4.99567 1.32 6.208 1.85633C7.11267 2.25633 7.46667 2.559 7.46667 3.58433V14.3333C6.081 13.0833 4.85133 12.7333 0 12.7333V1H1.06667Z",
    fill: fill
  }));
};
IconBookOpen.defaultProps = {
  fill: 'black'
};
IconBookOpen.propTypes = Object.assign({
  fill: _propTypes.default.string
}, _Icon.propTypes);
var _default = exports.default = IconBookOpen;